module.exports = __webpack_public_path__ + "img/bannow_1.4e908b4c.webp";